"use strict";
import React, { Component } from "react";
import Table from "./Table";

class Tarjeta extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return <div>
            <Table
                tarjetas={this.props.tarjetas}
                modalidadDistribucionLimiteId={this.props.modalidadDistribucionLimiteId}
                limiteCompraCodigo={this.props.limiteCompraCodigo}
            />
        </div>
    }

}
export default Tarjeta;